import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICommonPermitFieldsFragment_AttachmentPermitField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  attachmentValues?: Array<{
    fileName: string
    size: string
    url: string
  } | null> | null
}

export type ICommonPermitFieldsFragment_ChecklistAnswerItemPermitField_Fragment =
  {
    fieldId: any
    type: Types.PermitFieldType
    instanceId: any
    parentInstanceId?: any | null
    parentValueIndex?: number | null
    checklistValues?: Array<{
      checklistItemId?: any | null
      answer?: boolean | null
    } | null> | null
  }

export type ICommonPermitFieldsFragment_DateTimePermitField_Fragment = {
  dateTimeValues?: Array<any | null> | null
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
}

export type ICommonPermitFieldsFragment_LocationPermitField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  locationValues?: Array<{
    id: any
    type?: Types.LocationType | null
    levels?: Array<string | null> | null
    preciseLocation?: {
      bearing?: number | null
      pitch?: number | null
      latitude?: number | null
      longitude?: number | null
      zoom?: number | null
      globeViewId?: any | null
      imageUrl?: string | null
      overviewImageUrl?: string | null
    } | null
  } | null> | null
}

export type ICommonPermitFieldsFragment_MaterialFormField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  materialValues?: Array<{
    materialId: any
    procurementId?: string | null
  } | null> | null
}

export type ICommonPermitFieldsFragment_MaterialResourceFormField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  materialResourceValues?: Array<{ locationId: any } | null> | null
}

export type ICommonPermitFieldsFragment_MeasurePermitField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  measureValues?: Array<{
    units?: string | null
    value?: string | null
  } | null> | null
}

export type ICommonPermitFieldsFragment_ObjectIdPermitField_Fragment = {
  objectIdValues?: Array<any | null> | null
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
}

export type ICommonPermitFieldsFragment_RichTextFormField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  richTextValues?: Array<{
    content?: string | null
    attachments?: Array<{
      fileName: string
      size: string
      url: string
    } | null> | null
  } | null> | null
}

export type ICommonPermitFieldsFragment_SignaturePermitField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
  signatureValues?: Array<{
    dataUrl?: string | null
    fontFamily?: string | null
    signatureType: Types.SignatureType
    typedValue?: string | null
    timestamp?: any | null
    userId?: any | null
  } | null> | null
}

export type ICommonPermitFieldsFragment_StringPermitField_Fragment = {
  stringValues?: Array<string | null> | null
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
}

export type ICommonPermitFieldsFragment_TablePermitField_Fragment = {
  fieldId: any
  type: Types.PermitFieldType
  instanceId: any
  parentInstanceId?: any | null
  parentValueIndex?: number | null
}

export type ICommonPermitFieldsFragmentFragment =
  | ICommonPermitFieldsFragment_AttachmentPermitField_Fragment
  | ICommonPermitFieldsFragment_ChecklistAnswerItemPermitField_Fragment
  | ICommonPermitFieldsFragment_DateTimePermitField_Fragment
  | ICommonPermitFieldsFragment_LocationPermitField_Fragment
  | ICommonPermitFieldsFragment_MaterialFormField_Fragment
  | ICommonPermitFieldsFragment_MaterialResourceFormField_Fragment
  | ICommonPermitFieldsFragment_MeasurePermitField_Fragment
  | ICommonPermitFieldsFragment_ObjectIdPermitField_Fragment
  | ICommonPermitFieldsFragment_RichTextFormField_Fragment
  | ICommonPermitFieldsFragment_SignaturePermitField_Fragment
  | ICommonPermitFieldsFragment_StringPermitField_Fragment
  | ICommonPermitFieldsFragment_TablePermitField_Fragment

export type IPermitModelFieldsFragment = {
  createdAt?: any | null
  createdBy: any
  endDate: any
  id?: any | null
  projectId: any
  startDate: any
  status: Types.SitePermitStatus
  threadId?: any | null
  title?: string | null
  typeId: any
  initialType?: string | null
  categoryId?: any | null
  linkedIn?: Array<any | null> | null
  linkedWorkflows?: Array<any | null> | null
  updatedAt?: any | null
  code?: string | null
  currentWorkflowStepId: any
  workflowStepLevel?: number | null
  isAutoActivationEnabled?: boolean | null
  recurringSettingsId?: any | null
  stepRoundId?: any | null
  isDeleted?: boolean | null
  isAllDay?: boolean | null
  isLateRequest?: boolean | null
  specificInspectionOptions?: {
    deadlineTime?: any | null
    inspectionFrequency?: number | null
    inspectionFrequencyType?: Types.CalendricalType | null
    selectedDaysToRepeat?: Array<number | null> | null
  } | null
  stepSubmissions?: Array<{
    stepId: any
    userId: any
    ruleId?: any | null
    roundId?: any | null
    submittedAt: any
    fields?: Array<
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          attachmentValues?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          checklistValues?: Array<{
            checklistItemId?: any | null
            answer?: boolean | null
          } | null> | null
        }
      | {
          dateTimeValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          locationValues?: Array<{
            id: any
            type?: Types.LocationType | null
            levels?: Array<string | null> | null
            preciseLocation?: {
              bearing?: number | null
              pitch?: number | null
              latitude?: number | null
              longitude?: number | null
              zoom?: number | null
              globeViewId?: any | null
              imageUrl?: string | null
              overviewImageUrl?: string | null
            } | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialValues?: Array<{
            materialId: any
            procurementId?: string | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialResourceValues?: Array<{ locationId: any } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          measureValues?: Array<{
            units?: string | null
            value?: string | null
          } | null> | null
        }
      | {
          objectIdValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          richTextValues?: Array<{
            content?: string | null
            attachments?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          signatureValues?: Array<{
            dataUrl?: string | null
            fontFamily?: string | null
            signatureType: Types.SignatureType
            typedValue?: string | null
            timestamp?: any | null
            userId?: any | null
          } | null> | null
        }
      | {
          stringValues?: Array<string | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          tableValues?: Array<{
            cells?: Array<
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  attachmentValues?: Array<{
                    fileName: string
                    size: string
                    url: string
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  checklistValues?: Array<{
                    checklistItemId?: any | null
                    answer?: boolean | null
                  } | null> | null
                }
              | {
                  dateTimeValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  locationValues?: Array<{
                    id: any
                    type?: Types.LocationType | null
                    levels?: Array<string | null> | null
                    preciseLocation?: {
                      bearing?: number | null
                      pitch?: number | null
                      latitude?: number | null
                      longitude?: number | null
                      zoom?: number | null
                      globeViewId?: any | null
                      imageUrl?: string | null
                      overviewImageUrl?: string | null
                    } | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialValues?: Array<{
                    materialId: any
                    procurementId?: string | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialResourceValues?: Array<{
                    locationId: any
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  measureValues?: Array<{
                    units?: string | null
                    value?: string | null
                  } | null> | null
                }
              | {
                  objectIdValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  richTextValues?: Array<{
                    content?: string | null
                    attachments?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  signatureValues?: Array<{
                    dataUrl?: string | null
                    fontFamily?: string | null
                    signatureType: Types.SignatureType
                    typedValue?: string | null
                    timestamp?: any | null
                    userId?: any | null
                  } | null> | null
                }
              | {
                  stringValues?: Array<string | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | null
            > | null
          } | null> | null
        }
      | null
    > | null
  } | null> | null
  fields?: Array<
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        attachmentValues?: Array<{
          fileName: string
          size: string
          url: string
        } | null> | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        checklistValues?: Array<{
          checklistItemId?: any | null
          answer?: boolean | null
        } | null> | null
      }
    | {
        dateTimeValues?: Array<any | null> | null
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        locationValues?: Array<{
          id: any
          type?: Types.LocationType | null
          levels?: Array<string | null> | null
          preciseLocation?: {
            bearing?: number | null
            pitch?: number | null
            latitude?: number | null
            longitude?: number | null
            zoom?: number | null
            globeViewId?: any | null
            imageUrl?: string | null
            overviewImageUrl?: string | null
          } | null
        } | null> | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        materialValues?: Array<{
          materialId: any
          procurementId?: string | null
        } | null> | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        materialResourceValues?: Array<{ locationId: any } | null> | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        measureValues?: Array<{
          units?: string | null
          value?: string | null
        } | null> | null
      }
    | {
        objectIdValues?: Array<any | null> | null
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        richTextValues?: Array<{
          content?: string | null
          attachments?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
        } | null> | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        signatureValues?: Array<{
          dataUrl?: string | null
          fontFamily?: string | null
          signatureType: Types.SignatureType
          typedValue?: string | null
          timestamp?: any | null
          userId?: any | null
        } | null> | null
      }
    | {
        stringValues?: Array<string | null> | null
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
      }
    | {
        fieldId: any
        type: Types.PermitFieldType
        instanceId: any
        parentInstanceId?: any | null
        parentValueIndex?: number | null
        tableValues?: Array<{
          cells?: Array<
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                attachmentValues?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                checklistValues?: Array<{
                  checklistItemId?: any | null
                  answer?: boolean | null
                } | null> | null
              }
            | {
                dateTimeValues?: Array<any | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                locationValues?: Array<{
                  id: any
                  type?: Types.LocationType | null
                  levels?: Array<string | null> | null
                  preciseLocation?: {
                    bearing?: number | null
                    pitch?: number | null
                    latitude?: number | null
                    longitude?: number | null
                    zoom?: number | null
                    globeViewId?: any | null
                    imageUrl?: string | null
                    overviewImageUrl?: string | null
                  } | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                materialValues?: Array<{
                  materialId: any
                  procurementId?: string | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                materialResourceValues?: Array<{
                  locationId: any
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                measureValues?: Array<{
                  units?: string | null
                  value?: string | null
                } | null> | null
              }
            | {
                objectIdValues?: Array<any | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                richTextValues?: Array<{
                  content?: string | null
                  attachments?: Array<{
                    fileName: string
                    size: string
                    url: string
                  } | null> | null
                } | null> | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
                signatureValues?: Array<{
                  dataUrl?: string | null
                  fontFamily?: string | null
                  signatureType: Types.SignatureType
                  typedValue?: string | null
                  timestamp?: any | null
                  userId?: any | null
                } | null> | null
              }
            | {
                stringValues?: Array<string | null> | null
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | {
                fieldId: any
                type: Types.PermitFieldType
                instanceId: any
                parentInstanceId?: any | null
                parentValueIndex?: number | null
              }
            | null
          > | null
        } | null> | null
      }
    | null
  > | null
}

export type IGetSitePermitFacetsQueryVariables = Types.Exact<{
  filter: Types.ISitePermitFilterInput
}>

export type IGetSitePermitFacetsQuery = {
  sitePermitsFacets?: {
    typeFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    statusFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    categoryFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    companyFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    locationFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    equipmentFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    assigneeFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
    fileFilters?: Array<{
      key?: string | null
      count?: number | null
    } | null> | null
  } | null
}

export type IGetSitePermitAggregationListQueryVariables = Types.Exact<{
  filter: Types.ISitePermitFilterInput
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>
  sort?: Types.InputMaybe<Types.ISortBy>
}>

export type IGetSitePermitAggregationListQuery = {
  sitePermitsAggregation?: {
    data: Array<{
      createdAt?: any | null
      createdBy: any
      endDate: any
      id?: any | null
      projectId: any
      startDate: any
      status: Types.SitePermitStatus
      threadId?: any | null
      title?: string | null
      typeId: any
      initialType?: string | null
      categoryId?: any | null
      linkedIn?: Array<any | null> | null
      linkedWorkflows?: Array<any | null> | null
      updatedAt?: any | null
      code?: string | null
      currentWorkflowStepId: any
      workflowStepLevel?: number | null
      isAutoActivationEnabled?: boolean | null
      recurringSettingsId?: any | null
      stepRoundId?: any | null
      isDeleted?: boolean | null
      isAllDay?: boolean | null
      isLateRequest?: boolean | null
      specificInspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      stepSubmissions?: Array<{
        stepId: any
        userId: any
        ruleId?: any | null
        roundId?: any | null
        submittedAt: any
        fields?: Array<
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              attachmentValues?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              checklistValues?: Array<{
                checklistItemId?: any | null
                answer?: boolean | null
              } | null> | null
            }
          | {
              dateTimeValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              locationValues?: Array<{
                id: any
                type?: Types.LocationType | null
                levels?: Array<string | null> | null
                preciseLocation?: {
                  bearing?: number | null
                  pitch?: number | null
                  latitude?: number | null
                  longitude?: number | null
                  zoom?: number | null
                  globeViewId?: any | null
                  imageUrl?: string | null
                  overviewImageUrl?: string | null
                } | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialValues?: Array<{
                materialId: any
                procurementId?: string | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialResourceValues?: Array<{ locationId: any } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              measureValues?: Array<{
                units?: string | null
                value?: string | null
              } | null> | null
            }
          | {
              objectIdValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              richTextValues?: Array<{
                content?: string | null
                attachments?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              signatureValues?: Array<{
                dataUrl?: string | null
                fontFamily?: string | null
                signatureType: Types.SignatureType
                typedValue?: string | null
                timestamp?: any | null
                userId?: any | null
              } | null> | null
            }
          | {
              stringValues?: Array<string | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              tableValues?: Array<{
                cells?: Array<
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      attachmentValues?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      checklistValues?: Array<{
                        checklistItemId?: any | null
                        answer?: boolean | null
                      } | null> | null
                    }
                  | {
                      dateTimeValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      locationValues?: Array<{
                        id: any
                        type?: Types.LocationType | null
                        levels?: Array<string | null> | null
                        preciseLocation?: {
                          bearing?: number | null
                          pitch?: number | null
                          latitude?: number | null
                          longitude?: number | null
                          zoom?: number | null
                          globeViewId?: any | null
                          imageUrl?: string | null
                          overviewImageUrl?: string | null
                        } | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialValues?: Array<{
                        materialId: any
                        procurementId?: string | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialResourceValues?: Array<{
                        locationId: any
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      measureValues?: Array<{
                        units?: string | null
                        value?: string | null
                      } | null> | null
                    }
                  | {
                      objectIdValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      richTextValues?: Array<{
                        content?: string | null
                        attachments?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      signatureValues?: Array<{
                        dataUrl?: string | null
                        fontFamily?: string | null
                        signatureType: Types.SignatureType
                        typedValue?: string | null
                        timestamp?: any | null
                        userId?: any | null
                      } | null> | null
                    }
                  | {
                      stringValues?: Array<string | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | null
                > | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    }>
  } | null
}

export type ISaveSitePermitsMutationVariables = Types.Exact<{
  permits:
    | Array<Types.InputMaybe<Types.IPermitWithFieldsInput>>
    | Types.InputMaybe<Types.IPermitWithFieldsInput>
}>

export type ISaveSitePermitsMutation = {
  saveManySitePermits?: Array<{
    createdAt?: any | null
    createdBy: any
    endDate: any
    id?: any | null
    projectId: any
    startDate: any
    status: Types.SitePermitStatus
    threadId?: any | null
    title?: string | null
    typeId: any
    initialType?: string | null
    categoryId?: any | null
    linkedIn?: Array<any | null> | null
    linkedWorkflows?: Array<any | null> | null
    updatedAt?: any | null
    code?: string | null
    currentWorkflowStepId: any
    workflowStepLevel?: number | null
    isAutoActivationEnabled?: boolean | null
    recurringSettingsId?: any | null
    stepRoundId?: any | null
    isDeleted?: boolean | null
    isAllDay?: boolean | null
    isLateRequest?: boolean | null
    specificInspectionOptions?: {
      deadlineTime?: any | null
      inspectionFrequency?: number | null
      inspectionFrequencyType?: Types.CalendricalType | null
      selectedDaysToRepeat?: Array<number | null> | null
    } | null
    stepSubmissions?: Array<{
      stepId: any
      userId: any
      ruleId?: any | null
      roundId?: any | null
      submittedAt: any
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    } | null> | null
    fields?: Array<
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          attachmentValues?: Array<{
            fileName: string
            size: string
            url: string
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          checklistValues?: Array<{
            checklistItemId?: any | null
            answer?: boolean | null
          } | null> | null
        }
      | {
          dateTimeValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          locationValues?: Array<{
            id: any
            type?: Types.LocationType | null
            levels?: Array<string | null> | null
            preciseLocation?: {
              bearing?: number | null
              pitch?: number | null
              latitude?: number | null
              longitude?: number | null
              zoom?: number | null
              globeViewId?: any | null
              imageUrl?: string | null
              overviewImageUrl?: string | null
            } | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialValues?: Array<{
            materialId: any
            procurementId?: string | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          materialResourceValues?: Array<{ locationId: any } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          measureValues?: Array<{
            units?: string | null
            value?: string | null
          } | null> | null
        }
      | {
          objectIdValues?: Array<any | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          richTextValues?: Array<{
            content?: string | null
            attachments?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          } | null> | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          signatureValues?: Array<{
            dataUrl?: string | null
            fontFamily?: string | null
            signatureType: Types.SignatureType
            typedValue?: string | null
            timestamp?: any | null
            userId?: any | null
          } | null> | null
        }
      | {
          stringValues?: Array<string | null> | null
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
        }
      | {
          fieldId: any
          type: Types.PermitFieldType
          instanceId: any
          parentInstanceId?: any | null
          parentValueIndex?: number | null
          tableValues?: Array<{
            cells?: Array<
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  attachmentValues?: Array<{
                    fileName: string
                    size: string
                    url: string
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  checklistValues?: Array<{
                    checklistItemId?: any | null
                    answer?: boolean | null
                  } | null> | null
                }
              | {
                  dateTimeValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  locationValues?: Array<{
                    id: any
                    type?: Types.LocationType | null
                    levels?: Array<string | null> | null
                    preciseLocation?: {
                      bearing?: number | null
                      pitch?: number | null
                      latitude?: number | null
                      longitude?: number | null
                      zoom?: number | null
                      globeViewId?: any | null
                      imageUrl?: string | null
                      overviewImageUrl?: string | null
                    } | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialValues?: Array<{
                    materialId: any
                    procurementId?: string | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  materialResourceValues?: Array<{
                    locationId: any
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  measureValues?: Array<{
                    units?: string | null
                    value?: string | null
                  } | null> | null
                }
              | {
                  objectIdValues?: Array<any | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  richTextValues?: Array<{
                    content?: string | null
                    attachments?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  } | null> | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                  signatureValues?: Array<{
                    dataUrl?: string | null
                    fontFamily?: string | null
                    signatureType: Types.SignatureType
                    typedValue?: string | null
                    timestamp?: any | null
                    userId?: any | null
                  } | null> | null
                }
              | {
                  stringValues?: Array<string | null> | null
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | {
                  fieldId: any
                  type: Types.PermitFieldType
                  instanceId: any
                  parentInstanceId?: any | null
                  parentValueIndex?: number | null
                }
              | null
            > | null
          } | null> | null
        }
      | null
    > | null
  } | null> | null
}

export type ICreateRecurringWorkflowsMutationVariables = Types.Exact<{
  workflow: Types.IPermitWithFieldsInput
  recurringSettings: Types.IRecurringWorkflowSettingsInput
  timezoneId: Types.Scalars['String']['input']
}>

export type ICreateRecurringWorkflowsMutation = {
  createRecurringWorkflows?: {
    createdWorkflows: Array<{
      createdAt?: any | null
      createdBy: any
      endDate: any
      id?: any | null
      projectId: any
      startDate: any
      status: Types.SitePermitStatus
      threadId?: any | null
      title?: string | null
      typeId: any
      initialType?: string | null
      categoryId?: any | null
      linkedIn?: Array<any | null> | null
      linkedWorkflows?: Array<any | null> | null
      updatedAt?: any | null
      code?: string | null
      currentWorkflowStepId: any
      workflowStepLevel?: number | null
      isAutoActivationEnabled?: boolean | null
      recurringSettingsId?: any | null
      stepRoundId?: any | null
      isDeleted?: boolean | null
      isAllDay?: boolean | null
      isLateRequest?: boolean | null
      specificInspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      stepSubmissions?: Array<{
        stepId: any
        userId: any
        ruleId?: any | null
        roundId?: any | null
        submittedAt: any
        fields?: Array<
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              attachmentValues?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              checklistValues?: Array<{
                checklistItemId?: any | null
                answer?: boolean | null
              } | null> | null
            }
          | {
              dateTimeValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              locationValues?: Array<{
                id: any
                type?: Types.LocationType | null
                levels?: Array<string | null> | null
                preciseLocation?: {
                  bearing?: number | null
                  pitch?: number | null
                  latitude?: number | null
                  longitude?: number | null
                  zoom?: number | null
                  globeViewId?: any | null
                  imageUrl?: string | null
                  overviewImageUrl?: string | null
                } | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialValues?: Array<{
                materialId: any
                procurementId?: string | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialResourceValues?: Array<{ locationId: any } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              measureValues?: Array<{
                units?: string | null
                value?: string | null
              } | null> | null
            }
          | {
              objectIdValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              richTextValues?: Array<{
                content?: string | null
                attachments?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              signatureValues?: Array<{
                dataUrl?: string | null
                fontFamily?: string | null
                signatureType: Types.SignatureType
                typedValue?: string | null
                timestamp?: any | null
                userId?: any | null
              } | null> | null
            }
          | {
              stringValues?: Array<string | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              tableValues?: Array<{
                cells?: Array<
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      attachmentValues?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      checklistValues?: Array<{
                        checklistItemId?: any | null
                        answer?: boolean | null
                      } | null> | null
                    }
                  | {
                      dateTimeValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      locationValues?: Array<{
                        id: any
                        type?: Types.LocationType | null
                        levels?: Array<string | null> | null
                        preciseLocation?: {
                          bearing?: number | null
                          pitch?: number | null
                          latitude?: number | null
                          longitude?: number | null
                          zoom?: number | null
                          globeViewId?: any | null
                          imageUrl?: string | null
                          overviewImageUrl?: string | null
                        } | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialValues?: Array<{
                        materialId: any
                        procurementId?: string | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialResourceValues?: Array<{
                        locationId: any
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      measureValues?: Array<{
                        units?: string | null
                        value?: string | null
                      } | null> | null
                    }
                  | {
                      objectIdValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      richTextValues?: Array<{
                        content?: string | null
                        attachments?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      signatureValues?: Array<{
                        dataUrl?: string | null
                        fontFamily?: string | null
                        signatureType: Types.SignatureType
                        typedValue?: string | null
                        timestamp?: any | null
                        userId?: any | null
                      } | null> | null
                    }
                  | {
                      stringValues?: Array<string | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | null
                > | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    } | null>
    blockedWorkflows: Array<{
      reason: Types.BlockingReason
      locationId?: any | null
      locationName?: string | null
      blockedDate: any
    } | null>
  } | null
}

export type IDeleteFormsMutationVariables = Types.Exact<{
  ids:
    | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
    | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IDeleteFormsMutation = {
  softDeleteManyForms?: Array<any | null> | null
}

export type IDeleteThisAndFutureFormsMutationVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteThisAndFutureFormsMutation = {
  deleteThisAndFutureForms?: Array<any | null> | null
}

export type IDeleteDraftPermitsMutationVariables = Types.Exact<{
  ids:
    | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
    | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IDeleteDraftPermitsMutation = {
  deleteManyDraftPermits?: Array<any | null> | null
}

export type IListenToSitePermitSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  currentUserId?: Types.InputMaybe<Types.Scalars['ObjectId']['input']>
}>

export type IListenToSitePermitSubscription = {
  sitePermit?: {
    id?: any | null
    item?: {
      createdAt?: any | null
      createdBy: any
      endDate: any
      id?: any | null
      projectId: any
      startDate: any
      status: Types.SitePermitStatus
      threadId?: any | null
      title?: string | null
      typeId: any
      initialType?: string | null
      categoryId?: any | null
      linkedIn?: Array<any | null> | null
      linkedWorkflows?: Array<any | null> | null
      updatedAt?: any | null
      code?: string | null
      currentWorkflowStepId: any
      workflowStepLevel?: number | null
      isAutoActivationEnabled?: boolean | null
      recurringSettingsId?: any | null
      stepRoundId?: any | null
      isDeleted?: boolean | null
      isAllDay?: boolean | null
      isLateRequest?: boolean | null
      specificInspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      stepSubmissions?: Array<{
        stepId: any
        userId: any
        ruleId?: any | null
        roundId?: any | null
        submittedAt: any
        fields?: Array<
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              attachmentValues?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              checklistValues?: Array<{
                checklistItemId?: any | null
                answer?: boolean | null
              } | null> | null
            }
          | {
              dateTimeValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              locationValues?: Array<{
                id: any
                type?: Types.LocationType | null
                levels?: Array<string | null> | null
                preciseLocation?: {
                  bearing?: number | null
                  pitch?: number | null
                  latitude?: number | null
                  longitude?: number | null
                  zoom?: number | null
                  globeViewId?: any | null
                  imageUrl?: string | null
                  overviewImageUrl?: string | null
                } | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialValues?: Array<{
                materialId: any
                procurementId?: string | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialResourceValues?: Array<{ locationId: any } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              measureValues?: Array<{
                units?: string | null
                value?: string | null
              } | null> | null
            }
          | {
              objectIdValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              richTextValues?: Array<{
                content?: string | null
                attachments?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              signatureValues?: Array<{
                dataUrl?: string | null
                fontFamily?: string | null
                signatureType: Types.SignatureType
                typedValue?: string | null
                timestamp?: any | null
                userId?: any | null
              } | null> | null
            }
          | {
              stringValues?: Array<string | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              tableValues?: Array<{
                cells?: Array<
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      attachmentValues?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      checklistValues?: Array<{
                        checklistItemId?: any | null
                        answer?: boolean | null
                      } | null> | null
                    }
                  | {
                      dateTimeValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      locationValues?: Array<{
                        id: any
                        type?: Types.LocationType | null
                        levels?: Array<string | null> | null
                        preciseLocation?: {
                          bearing?: number | null
                          pitch?: number | null
                          latitude?: number | null
                          longitude?: number | null
                          zoom?: number | null
                          globeViewId?: any | null
                          imageUrl?: string | null
                          overviewImageUrl?: string | null
                        } | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialValues?: Array<{
                        materialId: any
                        procurementId?: string | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialResourceValues?: Array<{
                        locationId: any
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      measureValues?: Array<{
                        units?: string | null
                        value?: string | null
                      } | null> | null
                    }
                  | {
                      objectIdValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      richTextValues?: Array<{
                        content?: string | null
                        attachments?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      signatureValues?: Array<{
                        dataUrl?: string | null
                        fontFamily?: string | null
                        signatureType: Types.SignatureType
                        typedValue?: string | null
                        timestamp?: any | null
                        userId?: any | null
                      } | null> | null
                    }
                  | {
                      stringValues?: Array<string | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | null
                > | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    } | null
  } | null
}

export type IListenToSitePermitByIdSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IListenToSitePermitByIdSubscription = {
  sitePermit?: {
    id?: any | null
    item?: {
      createdAt?: any | null
      createdBy: any
      endDate: any
      id?: any | null
      projectId: any
      startDate: any
      status: Types.SitePermitStatus
      threadId?: any | null
      title?: string | null
      typeId: any
      initialType?: string | null
      categoryId?: any | null
      linkedIn?: Array<any | null> | null
      linkedWorkflows?: Array<any | null> | null
      updatedAt?: any | null
      code?: string | null
      currentWorkflowStepId: any
      workflowStepLevel?: number | null
      isAutoActivationEnabled?: boolean | null
      recurringSettingsId?: any | null
      stepRoundId?: any | null
      isDeleted?: boolean | null
      isAllDay?: boolean | null
      isLateRequest?: boolean | null
      specificInspectionOptions?: {
        deadlineTime?: any | null
        inspectionFrequency?: number | null
        inspectionFrequencyType?: Types.CalendricalType | null
        selectedDaysToRepeat?: Array<number | null> | null
      } | null
      stepSubmissions?: Array<{
        stepId: any
        userId: any
        ruleId?: any | null
        roundId?: any | null
        submittedAt: any
        fields?: Array<
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              attachmentValues?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              checklistValues?: Array<{
                checklistItemId?: any | null
                answer?: boolean | null
              } | null> | null
            }
          | {
              dateTimeValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              locationValues?: Array<{
                id: any
                type?: Types.LocationType | null
                levels?: Array<string | null> | null
                preciseLocation?: {
                  bearing?: number | null
                  pitch?: number | null
                  latitude?: number | null
                  longitude?: number | null
                  zoom?: number | null
                  globeViewId?: any | null
                  imageUrl?: string | null
                  overviewImageUrl?: string | null
                } | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialValues?: Array<{
                materialId: any
                procurementId?: string | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              materialResourceValues?: Array<{ locationId: any } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              measureValues?: Array<{
                units?: string | null
                value?: string | null
              } | null> | null
            }
          | {
              objectIdValues?: Array<any | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              richTextValues?: Array<{
                content?: string | null
                attachments?: Array<{
                  fileName: string
                  size: string
                  url: string
                } | null> | null
              } | null> | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              signatureValues?: Array<{
                dataUrl?: string | null
                fontFamily?: string | null
                signatureType: Types.SignatureType
                typedValue?: string | null
                timestamp?: any | null
                userId?: any | null
              } | null> | null
            }
          | {
              stringValues?: Array<string | null> | null
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
            }
          | {
              fieldId: any
              type: Types.PermitFieldType
              instanceId: any
              parentInstanceId?: any | null
              parentValueIndex?: number | null
              tableValues?: Array<{
                cells?: Array<
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      attachmentValues?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      checklistValues?: Array<{
                        checklistItemId?: any | null
                        answer?: boolean | null
                      } | null> | null
                    }
                  | {
                      dateTimeValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      locationValues?: Array<{
                        id: any
                        type?: Types.LocationType | null
                        levels?: Array<string | null> | null
                        preciseLocation?: {
                          bearing?: number | null
                          pitch?: number | null
                          latitude?: number | null
                          longitude?: number | null
                          zoom?: number | null
                          globeViewId?: any | null
                          imageUrl?: string | null
                          overviewImageUrl?: string | null
                        } | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialValues?: Array<{
                        materialId: any
                        procurementId?: string | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      materialResourceValues?: Array<{
                        locationId: any
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      measureValues?: Array<{
                        units?: string | null
                        value?: string | null
                      } | null> | null
                    }
                  | {
                      objectIdValues?: Array<any | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      richTextValues?: Array<{
                        content?: string | null
                        attachments?: Array<{
                          fileName: string
                          size: string
                          url: string
                        } | null> | null
                      } | null> | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                      signatureValues?: Array<{
                        dataUrl?: string | null
                        fontFamily?: string | null
                        signatureType: Types.SignatureType
                        typedValue?: string | null
                        timestamp?: any | null
                        userId?: any | null
                      } | null> | null
                    }
                  | {
                      stringValues?: Array<string | null> | null
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | {
                      fieldId: any
                      type: Types.PermitFieldType
                      instanceId: any
                      parentInstanceId?: any | null
                      parentValueIndex?: number | null
                    }
                  | null
                > | null
              } | null> | null
            }
          | null
        > | null
      } | null> | null
      fields?: Array<
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            attachmentValues?: Array<{
              fileName: string
              size: string
              url: string
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            checklistValues?: Array<{
              checklistItemId?: any | null
              answer?: boolean | null
            } | null> | null
          }
        | {
            dateTimeValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            locationValues?: Array<{
              id: any
              type?: Types.LocationType | null
              levels?: Array<string | null> | null
              preciseLocation?: {
                bearing?: number | null
                pitch?: number | null
                latitude?: number | null
                longitude?: number | null
                zoom?: number | null
                globeViewId?: any | null
                imageUrl?: string | null
                overviewImageUrl?: string | null
              } | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialValues?: Array<{
              materialId: any
              procurementId?: string | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            materialResourceValues?: Array<{ locationId: any } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            measureValues?: Array<{
              units?: string | null
              value?: string | null
            } | null> | null
          }
        | {
            objectIdValues?: Array<any | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            richTextValues?: Array<{
              content?: string | null
              attachments?: Array<{
                fileName: string
                size: string
                url: string
              } | null> | null
            } | null> | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            signatureValues?: Array<{
              dataUrl?: string | null
              fontFamily?: string | null
              signatureType: Types.SignatureType
              typedValue?: string | null
              timestamp?: any | null
              userId?: any | null
            } | null> | null
          }
        | {
            stringValues?: Array<string | null> | null
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
          }
        | {
            fieldId: any
            type: Types.PermitFieldType
            instanceId: any
            parentInstanceId?: any | null
            parentValueIndex?: number | null
            tableValues?: Array<{
              cells?: Array<
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    attachmentValues?: Array<{
                      fileName: string
                      size: string
                      url: string
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    checklistValues?: Array<{
                      checklistItemId?: any | null
                      answer?: boolean | null
                    } | null> | null
                  }
                | {
                    dateTimeValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    locationValues?: Array<{
                      id: any
                      type?: Types.LocationType | null
                      levels?: Array<string | null> | null
                      preciseLocation?: {
                        bearing?: number | null
                        pitch?: number | null
                        latitude?: number | null
                        longitude?: number | null
                        zoom?: number | null
                        globeViewId?: any | null
                        imageUrl?: string | null
                        overviewImageUrl?: string | null
                      } | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialValues?: Array<{
                      materialId: any
                      procurementId?: string | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    materialResourceValues?: Array<{
                      locationId: any
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    measureValues?: Array<{
                      units?: string | null
                      value?: string | null
                    } | null> | null
                  }
                | {
                    objectIdValues?: Array<any | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    richTextValues?: Array<{
                      content?: string | null
                      attachments?: Array<{
                        fileName: string
                        size: string
                        url: string
                      } | null> | null
                    } | null> | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                    signatureValues?: Array<{
                      dataUrl?: string | null
                      fontFamily?: string | null
                      signatureType: Types.SignatureType
                      typedValue?: string | null
                      timestamp?: any | null
                      userId?: any | null
                    } | null> | null
                  }
                | {
                    stringValues?: Array<string | null> | null
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | {
                    fieldId: any
                    type: Types.PermitFieldType
                    instanceId: any
                    parentInstanceId?: any | null
                    parentValueIndex?: number | null
                  }
                | null
              > | null
            } | null> | null
          }
        | null
      > | null
    } | null
  } | null
}

export const CommonPermitFieldsFragmentFragmentDoc = gql`
  fragment CommonPermitFieldsFragment on PermitFieldInterface {
    fieldId
    type
    instanceId
    parentInstanceId
    parentValueIndex
    ... on AttachmentPermitField {
      attachmentValues {
        fileName
        size
        url
      }
    }
    ... on ChecklistAnswerItemPermitField {
      checklistValues {
        checklistItemId
        answer
      }
    }
    ... on DateTimePermitField {
      dateTimeValues
    }
    ... on LocationPermitField {
      locationValues {
        id
        type
        levels
        preciseLocation {
          bearing
          pitch
          latitude
          longitude
          zoom
          globeViewId
          imageUrl
          overviewImageUrl
        }
      }
    }
    ... on MeasurePermitField {
      measureValues {
        units
        value
      }
    }
    ... on StringPermitField {
      stringValues
    }
    ... on ObjectIdPermitField {
      objectIdValues
    }
    ... on MaterialFormField {
      materialValues {
        materialId
        procurementId
      }
    }
    ... on MaterialResourceFormField {
      materialResourceValues {
        locationId
      }
    }
    ... on RichTextFormField {
      richTextValues {
        content
        attachments {
          fileName
          size
          url
        }
      }
    }
    ... on SignaturePermitField {
      signatureValues {
        dataUrl
        fontFamily
        signatureType
        typedValue
        timestamp
        userId
      }
    }
  }
`
export const PermitModelFieldsFragmentDoc = gql`
  fragment PermitModelFields on SitePermit {
    createdAt
    createdBy
    endDate
    id
    projectId
    startDate
    status
    threadId
    title
    typeId
    initialType
    categoryId
    linkedIn
    linkedWorkflows
    updatedAt
    code
    specificInspectionOptions {
      deadlineTime
      inspectionFrequency
      inspectionFrequencyType
      selectedDaysToRepeat
    }
    currentWorkflowStepId
    workflowStepLevel
    isAutoActivationEnabled
    recurringSettingsId
    stepRoundId
    stepSubmissions {
      stepId
      userId
      ruleId
      roundId
      submittedAt
      fields {
        ...CommonPermitFieldsFragment
        ... on TablePermitField {
          tableValues {
            cells {
              ...CommonPermitFieldsFragment
            }
          }
        }
      }
    }
    fields {
      ...CommonPermitFieldsFragment
      ... on TablePermitField {
        tableValues {
          cells {
            ...CommonPermitFieldsFragment
          }
        }
      }
    }
    isDeleted
    isAllDay
    isLateRequest
  }
  ${CommonPermitFieldsFragmentFragmentDoc}
`
export const GetSitePermitFacetsDocument = gql`
  query GetSitePermitFacets($filter: SitePermitFilterInput!) {
    sitePermitsFacets(filter: $filter) {
      typeFilters {
        key
        count
      }
      statusFilters {
        key
        count
      }
      categoryFilters {
        key
        count
      }
      companyFilters {
        key
        count
      }
      locationFilters {
        key
        count
      }
      equipmentFilters {
        key
        count
      }
      assigneeFilters {
        key
        count
      }
      fileFilters {
        key
        count
      }
    }
  }
`

/**
 * __useGetSitePermitFacetsQuery__
 *
 * To run a query within a React component, call `useGetSitePermitFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitePermitFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitePermitFacetsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSitePermitFacetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetSitePermitFacetsQuery,
    IGetSitePermitFacetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSitePermitFacetsQuery,
    IGetSitePermitFacetsQueryVariables
  >(GetSitePermitFacetsDocument, options)
}
export function useGetSitePermitFacetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSitePermitFacetsQuery,
    IGetSitePermitFacetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSitePermitFacetsQuery,
    IGetSitePermitFacetsQueryVariables
  >(GetSitePermitFacetsDocument, options)
}
export type GetSitePermitFacetsQueryHookResult = ReturnType<
  typeof useGetSitePermitFacetsQuery
>
export type GetSitePermitFacetsLazyQueryHookResult = ReturnType<
  typeof useGetSitePermitFacetsLazyQuery
>
export type GetSitePermitFacetsQueryResult = Apollo.QueryResult<
  IGetSitePermitFacetsQuery,
  IGetSitePermitFacetsQueryVariables
>
export const GetSitePermitAggregationListDocument = gql`
  query GetSitePermitAggregationList(
    $filter: SitePermitFilterInput!
    $offset: Int
    $limit: Int
    $sort: SortBy
  ) {
    sitePermitsAggregation(
      filter: $filter
      offset: $offset
      limit: $limit
      sort: $sort
    ) {
      data {
        ...PermitModelFields
      }
    }
  }
  ${PermitModelFieldsFragmentDoc}
`

/**
 * __useGetSitePermitAggregationListQuery__
 *
 * To run a query within a React component, call `useGetSitePermitAggregationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSitePermitAggregationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSitePermitAggregationListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetSitePermitAggregationListQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >(GetSitePermitAggregationListDocument, options)
}
export function useGetSitePermitAggregationListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >(GetSitePermitAggregationListDocument, options)
}
export type GetSitePermitAggregationListQueryHookResult = ReturnType<
  typeof useGetSitePermitAggregationListQuery
>
export type GetSitePermitAggregationListLazyQueryHookResult = ReturnType<
  typeof useGetSitePermitAggregationListLazyQuery
>
export type GetSitePermitAggregationListQueryResult = Apollo.QueryResult<
  IGetSitePermitAggregationListQuery,
  IGetSitePermitAggregationListQueryVariables
>
export const SaveSitePermitsDocument = gql`
  mutation SaveSitePermits($permits: [PermitWithFieldsInput]!) {
    saveManySitePermits(permits: $permits) {
      ...PermitModelFields
    }
  }
  ${PermitModelFieldsFragmentDoc}
`
export type ISaveSitePermitsMutationFn = Apollo.MutationFunction<
  ISaveSitePermitsMutation,
  ISaveSitePermitsMutationVariables
>

/**
 * __useSaveSitePermitsMutation__
 *
 * To run a mutation, you first call `useSaveSitePermitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSitePermitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSitePermitsMutation, { data, loading, error }] = useSaveSitePermitsMutation({
 *   variables: {
 *      permits: // value for 'permits'
 *   },
 * });
 */
export function useSaveSitePermitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveSitePermitsMutation,
    ISaveSitePermitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISaveSitePermitsMutation,
    ISaveSitePermitsMutationVariables
  >(SaveSitePermitsDocument, options)
}
export type SaveSitePermitsMutationHookResult = ReturnType<
  typeof useSaveSitePermitsMutation
>
export type SaveSitePermitsMutationResult =
  Apollo.MutationResult<ISaveSitePermitsMutation>
export type SaveSitePermitsMutationOptions = Apollo.BaseMutationOptions<
  ISaveSitePermitsMutation,
  ISaveSitePermitsMutationVariables
>
export const CreateRecurringWorkflowsDocument = gql`
  mutation CreateRecurringWorkflows(
    $workflow: PermitWithFieldsInput!
    $recurringSettings: RecurringWorkflowSettingsInput!
    $timezoneId: String!
  ) {
    createRecurringWorkflows(
      workflow: $workflow
      recurringSettings: $recurringSettings
      timezoneId: $timezoneId
    ) {
      createdWorkflows {
        ...PermitModelFields
      }
      blockedWorkflows {
        reason
        locationId
        locationName
        blockedDate
      }
    }
  }
  ${PermitModelFieldsFragmentDoc}
`
export type ICreateRecurringWorkflowsMutationFn = Apollo.MutationFunction<
  ICreateRecurringWorkflowsMutation,
  ICreateRecurringWorkflowsMutationVariables
>

/**
 * __useCreateRecurringWorkflowsMutation__
 *
 * To run a mutation, you first call `useCreateRecurringWorkflowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringWorkflowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringWorkflowsMutation, { data, loading, error }] = useCreateRecurringWorkflowsMutation({
 *   variables: {
 *      workflow: // value for 'workflow'
 *      recurringSettings: // value for 'recurringSettings'
 *      timezoneId: // value for 'timezoneId'
 *   },
 * });
 */
export function useCreateRecurringWorkflowsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateRecurringWorkflowsMutation,
    ICreateRecurringWorkflowsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateRecurringWorkflowsMutation,
    ICreateRecurringWorkflowsMutationVariables
  >(CreateRecurringWorkflowsDocument, options)
}
export type CreateRecurringWorkflowsMutationHookResult = ReturnType<
  typeof useCreateRecurringWorkflowsMutation
>
export type CreateRecurringWorkflowsMutationResult =
  Apollo.MutationResult<ICreateRecurringWorkflowsMutation>
export type CreateRecurringWorkflowsMutationOptions =
  Apollo.BaseMutationOptions<
    ICreateRecurringWorkflowsMutation,
    ICreateRecurringWorkflowsMutationVariables
  >
export const DeleteFormsDocument = gql`
  mutation DeleteForms($ids: [ObjectId]!) {
    softDeleteManyForms(ids: $ids)
  }
`
export type IDeleteFormsMutationFn = Apollo.MutationFunction<
  IDeleteFormsMutation,
  IDeleteFormsMutationVariables
>

/**
 * __useDeleteFormsMutation__
 *
 * To run a mutation, you first call `useDeleteFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFormsMutation, { data, loading, error }] = useDeleteFormsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteFormsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteFormsMutation,
    IDeleteFormsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteFormsMutation,
    IDeleteFormsMutationVariables
  >(DeleteFormsDocument, options)
}
export type DeleteFormsMutationHookResult = ReturnType<
  typeof useDeleteFormsMutation
>
export type DeleteFormsMutationResult =
  Apollo.MutationResult<IDeleteFormsMutation>
export type DeleteFormsMutationOptions = Apollo.BaseMutationOptions<
  IDeleteFormsMutation,
  IDeleteFormsMutationVariables
>
export const DeleteThisAndFutureFormsDocument = gql`
  mutation DeleteThisAndFutureForms($id: ObjectId!) {
    deleteThisAndFutureForms(id: $id)
  }
`
export type IDeleteThisAndFutureFormsMutationFn = Apollo.MutationFunction<
  IDeleteThisAndFutureFormsMutation,
  IDeleteThisAndFutureFormsMutationVariables
>

/**
 * __useDeleteThisAndFutureFormsMutation__
 *
 * To run a mutation, you first call `useDeleteThisAndFutureFormsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThisAndFutureFormsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThisAndFutureFormsMutation, { data, loading, error }] = useDeleteThisAndFutureFormsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThisAndFutureFormsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteThisAndFutureFormsMutation,
    IDeleteThisAndFutureFormsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteThisAndFutureFormsMutation,
    IDeleteThisAndFutureFormsMutationVariables
  >(DeleteThisAndFutureFormsDocument, options)
}
export type DeleteThisAndFutureFormsMutationHookResult = ReturnType<
  typeof useDeleteThisAndFutureFormsMutation
>
export type DeleteThisAndFutureFormsMutationResult =
  Apollo.MutationResult<IDeleteThisAndFutureFormsMutation>
export type DeleteThisAndFutureFormsMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteThisAndFutureFormsMutation,
    IDeleteThisAndFutureFormsMutationVariables
  >
export const DeleteDraftPermitsDocument = gql`
  mutation DeleteDraftPermits($ids: [ObjectId]!) {
    deleteManyDraftPermits(ids: $ids)
  }
`
export type IDeleteDraftPermitsMutationFn = Apollo.MutationFunction<
  IDeleteDraftPermitsMutation,
  IDeleteDraftPermitsMutationVariables
>

/**
 * __useDeleteDraftPermitsMutation__
 *
 * To run a mutation, you first call `useDeleteDraftPermitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDraftPermitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDraftPermitsMutation, { data, loading, error }] = useDeleteDraftPermitsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDraftPermitsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteDraftPermitsMutation,
    IDeleteDraftPermitsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteDraftPermitsMutation,
    IDeleteDraftPermitsMutationVariables
  >(DeleteDraftPermitsDocument, options)
}
export type DeleteDraftPermitsMutationHookResult = ReturnType<
  typeof useDeleteDraftPermitsMutation
>
export type DeleteDraftPermitsMutationResult =
  Apollo.MutationResult<IDeleteDraftPermitsMutation>
export type DeleteDraftPermitsMutationOptions = Apollo.BaseMutationOptions<
  IDeleteDraftPermitsMutation,
  IDeleteDraftPermitsMutationVariables
>
export const ListenToSitePermitDocument = gql`
  subscription ListenToSitePermit(
    $projectId: ObjectId!
    $currentUserId: ObjectId
  ) {
    sitePermit(projectId: $projectId, currentUserId: $currentUserId) {
      item {
        ...PermitModelFields
      }
      id
    }
  }
  ${PermitModelFieldsFragmentDoc}
`

/**
 * __useListenToSitePermitSubscription__
 *
 * To run a query within a React component, call `useListenToSitePermitSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToSitePermitSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToSitePermitSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      currentUserId: // value for 'currentUserId'
 *   },
 * });
 */
export function useListenToSitePermitSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToSitePermitSubscription,
    IListenToSitePermitSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToSitePermitSubscription,
    IListenToSitePermitSubscriptionVariables
  >(ListenToSitePermitDocument, options)
}
export type ListenToSitePermitSubscriptionHookResult = ReturnType<
  typeof useListenToSitePermitSubscription
>
export type ListenToSitePermitSubscriptionResult =
  Apollo.SubscriptionResult<IListenToSitePermitSubscription>
export const ListenToSitePermitByIdDocument = gql`
  subscription ListenToSitePermitById($id: ObjectId!) {
    sitePermit(id: $id) {
      item {
        ...PermitModelFields
      }
      id
    }
  }
  ${PermitModelFieldsFragmentDoc}
`

/**
 * __useListenToSitePermitByIdSubscription__
 *
 * To run a query within a React component, call `useListenToSitePermitByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenToSitePermitByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenToSitePermitByIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListenToSitePermitByIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenToSitePermitByIdSubscription,
    IListenToSitePermitByIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenToSitePermitByIdSubscription,
    IListenToSitePermitByIdSubscriptionVariables
  >(ListenToSitePermitByIdDocument, options)
}
export type ListenToSitePermitByIdSubscriptionHookResult = ReturnType<
  typeof useListenToSitePermitByIdSubscription
>
export type ListenToSitePermitByIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenToSitePermitByIdSubscription>
